"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WheelFrame;
require("core-js/modules/web.dom-collections.iterator.js");
var _stylesModule = _interopRequireDefault(require("./styles.module.css"));
var _react = require("react");
var _removeframe = require("../../assets/removeframe.svg");
var _fa = require("react-icons/fa");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// import uparrow from react icons

function WheelFrame(_ref) {
  let {
    Carusel,
    borderColor,
    backgroundColor,
    color,
    posterItems,
    BlockCategoryItem,
    onFrontPosterChange,
    onRemoveFrame,
    isRemovable,
    isExecuting = false
  } = _ref;
  const [upArrow, setUpArrow] = (0, _react.useState)(0);
  const [downArrow, setDownArrow] = (0, _react.useState)(0);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _stylesModule.default.frameContainer,
    style: {
      backgroundColor
    },
    children: [isRemovable && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _stylesModule.default.removeFrame,
      onClick: onRemoveFrame,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_removeframe.ReactComponent, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _stylesModule.default.blockCategoryIconContainer,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(BlockCategoryItem, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _stylesModule.default.outerSquare,
      style: {
        backgroundColor: color,
        border: "1px solid ".concat(borderColor)
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _stylesModule.default.upArrow,
        style: {
          border: "1px solid ".concat(borderColor)
        },
        onClick: () => setUpArrow(upArrow + 1),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fa.FaArrowUp, {
          className: _stylesModule.default.upArrowIcon,
          color: borderColor
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _stylesModule.default.innerSquare,
        style: {
          border: "1px solid ".concat(borderColor),
          boxShadow: isExecuting ? "inset 0px 0px 50px 5px ".concat(borderColor) : 'none'
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Carusel, {
          onUpArrow: upArrow,
          onDownArrow: downArrow,
          posterItems: posterItems,
          onFrontPosterChange: onFrontPosterChange
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _stylesModule.default.downArrow,
        style: {
          border: "1px solid ".concat(borderColor)
        },
        onClick: () => setDownArrow(downArrow + 1),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fa.FaArrowDown, {
          className: _stylesModule.default.downArrowIcon,
          color: borderColor
        })
      })]
    })]
  });
}